// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { NewsInfoResponseDTO } from "../api/backend-openapi";
import { NEWS_WORKFLOW_STATUS } from "./Constant";
import moment, { now } from "moment";

export const getStatusFrom = (news: NewsInfoResponseDTO): string => {
  if (
    NEWS_WORKFLOW_STATUS[news.status] === NEWS_WORKFLOW_STATUS.PUBLISHED &&
    news.scheduledAvailabilityDate &&
    moment(news.scheduledAvailabilityDate).isAfter(now())
  ) {
    return "WAITINGFORPUBLICATION";
  }
  return news.status;
};

export const getPublicationDateFrom = (
  news: NewsInfoResponseDTO
): Date | undefined => {
  if (news.publicationDate !== undefined && news.publicationDate !== null) {
    return news.scheduledAvailabilityDate
      ? news.scheduledAvailabilityDate
      : news.publicationDate;
  }
  return undefined;
};

export const canBeDeleted = (news: NewsInfoResponseDTO): boolean => {
  return news.publicationDate === undefined || news.publicationDate === null;
};
